<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
input{
  font-family: var(--font-family-poppins);
}
::placeholder {
  color: #B3B3B3 !important;
  font-family: var(--font-family-poppins);
  opacity: 1; /* Firefox */
}
/* .form-control {
    padding: 1% 4% 2.3% 4% !important;
    font-family: var(--font-family-poppins) !important;
    font-size: var(--font-size-sl) !important;
    } */
</style>
